/**
 * Field length limits for the `businesses` table.
 *
 * The drizzle schema imports these as `varchar(...)` length args; backend
 * validators + frontend zod schemas import them for the same checks.
 * Change here → next `pnpm db:generate` emits an ALTER COLUMN migration.
 */
export const BUSINESS_NAME_MAX_LENGTH = 255
export const REGISTRATION_NUMBER_MAX_LENGTH = 100
